export const strategyProperties = Object.freeze({
    email: Object.freeze({
        id: 'email',
        name: 'Email',
        icon: 'sym_r_mail',
        order: 1,
        route: 'LoginPage'
    }),
    github: Object.freeze({
        id: 'github',
        name: 'GitHub',
        domain: 'github.com',
        icon: 'img:/icons/brand-logo_github.svg',
        iconDark: 'img:/icons/brand-logo_github_white.svg',
        order: 1
    }),
    gitlab: Object.freeze({
        id: 'gitlab',
        name: 'GitLab',
        domain: 'gitlab.com',
        icon: 'img:/icons/brand-logo_gitlab.svg',
        order: 2
    }),
    google: Object.freeze({
        id: 'google',
        name: 'Google',
        domain: 'google.com',
        icon: 'img:/icons/brand-logo_google.svg',
        order: 3
    }),
    linkedin: Object.freeze({
        id: 'linkedin',
        name: 'LinkedIn',
        domain: 'linkedin.com',
        icon: 'img:/icons/brand-logo_linkedin.svg',
        order: 4
    })
});
